import React from "react";
import "./Sidebar.scss";
import { FileSpreadsheet, Home } from "lucide-react";
import logo from "../../assets/images/logo22.svg";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const iconSize = isOpen ? 18 : 18; // Can customize if needed

  const isActive = (path) => location.pathname === path;

  return (
    <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="logo" style={{ marginTop: "40px", cursor: "pointer" }}>
        <img
          src={logo}
          alt="Logo"
          onClick={() => {
            navigate("/categories");
          }}
        />
      </div>

      <nav className="nav-links">
        <button
          // className={`nav-item ${isActive("/dashboard") ? "active" : "inactive"}`}
          className={`nav-item active`}

          onClick={() => navigate("/dashboard")}
        >
          <Home size={iconSize} style={{ marginRight: "8px" }} />
          {isOpen && "Point of Sale"}
        </button>

        {/* <button
          className={`nav-item ${isActive("/dashboard/salesorderadvanced") ? "active" : "inactive"}`}
          onClick={() => navigate("/dashboard/salesorderadvanced")}
        >
          <FileSpreadsheet size={iconSize} style={{ marginRight: "8px" }} />
          {isOpen && "Sales Order Advanced"}
        </button> */}
      </nav>

      <button className="toggle-btn" onClick={toggleSidebar}>
        {isOpen ? "⏪" : "⏩"}
      </button>
    </aside>
  );
};

export default Sidebar;
